import {
  CERTIFICATIONS,
  SOCIAL_PLATFORMS,
  type SocialPlatform,
  type Certification,
  ORG_ICONS_BG_STYLES,
} from '@/constants/icons';

/**
 * Returns the appropriate PDF-compatible social media icon component based on the name.
 *
 * @param {string} name - The social media name to check
 * @returns The PDF-compatible icon component matching the name's platform
 */
export const getPDFSocialIcon = (name: string) => {
  const nameLower = name.toLowerCase();

  const matchedIcon = Object.keys(SOCIAL_PLATFORMS).find((key) =>
    nameLower.includes(key.toLowerCase()),
  ) as SocialPlatform | undefined;

  if (matchedIcon) {
    return SOCIAL_PLATFORMS[matchedIcon]!.pdfIcon;
  }

  return SOCIAL_PLATFORMS['DEFAULT']!.pdfIcon;
};

/**
 * Returns the appropriate PDF-compatible social media icon component based on the name.
 *
 * @param {string} name - The social media name to check
 * @returns The PDF-compatible icon component matching the name's platform
 */
export const getSocialIcon = (name: string) => {
  const nameLower = name.toLowerCase();

  const matchedIcon = Object.keys(SOCIAL_PLATFORMS).find((key) =>
    nameLower.includes(key.toLowerCase()),
  ) as SocialPlatform | undefined;

  if (matchedIcon) {
    return SOCIAL_PLATFORMS[matchedIcon]!.icon;
  }

  return SOCIAL_PLATFORMS['DEFAULT']!.icon;
};

export const getPDFCertificationIcon = (name: string) => {
  const urlLower = name.toLowerCase();
  const matchedIcon = Object.keys(CERTIFICATIONS).find((key) =>
    urlLower.includes(key.toLowerCase()),
  ) as Certification | undefined;

  if (matchedIcon) {
    return CERTIFICATIONS[matchedIcon]!.pdfIcon;
  }
  return CERTIFICATIONS['DEFAULT']!.pdfIcon;
};

export const getCertificationIcon = (name: string) => {
  const urlLower = name.toLowerCase();
  const matchedIcon = Object.keys(CERTIFICATIONS).find((key) =>
    urlLower.includes(key.toLowerCase()),
  ) as Certification | undefined;
  if (matchedIcon) {
    return CERTIFICATIONS[matchedIcon]!.icon;
  }
  return CERTIFICATIONS['DEFAULT']!.icon;
};

export const getCertificationBgClass = (org: string): string => {
  const DEFAULT_CERTIFICATION_BG = 'bg-coral';
  const lowerOrg = org.toLowerCase();
  const matchedStyle = ORG_ICONS_BG_STYLES.find((style) =>
    lowerOrg.includes(style.match),
  );

  return matchedStyle?.bgClass ?? DEFAULT_CERTIFICATION_BG;
};
